<template lang="html">
  <div class="">

    <toast-message :message="errmsg" type="error" :isToastEnable="toast" @close="(val) => toast = val" />

    <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
      You have only view permission.
    </div>
    <div class="threeColumnGrid">
      <div>

        <tl-select label="Select Quarter" labelText="quarter" :options="quarterList" v-model='formData.quarter_name' @change="quarterChanged($event)"
          name="quarterValue" :disabled="!ifTeamleaderAnchorPermission">
          <!-- v-validate="'required'" :classname="errors.has('quarterValue')" :errormsg="errors.first('quarterValue')" -->
        </tl-select>
      </div>
    </div>

    <!--<div class="margin-top-20">
      <div v-if="acknowledgementData.length">
        <data-table :columns="payGroupDataColumns" :tableData="acknowledgementData" :checkbox="false" :withForm="false" :showinrow="true"
          :showedit="false" :showhistory="false" @delete="deleteItem">
          <!-- <template v-slot:rowcontent="slotprops">
            <img class="sm-img" v-if="slotprops.value.column.key=='imgSrc'" :src="slotprops.value.record[slotprops.value.column.key]"
            />
            <p v-if="slotprops.value.column.key!='imgSrc' && slotprops.value.column.key !='attachments' && slotprops.value.column.key !='fileType'">{{slotprops.value.record[slotprops.value.column.key]}}</p>
            <div v-if="slotprops.value.column.key=='attachments'">
              <span class="attach-content" v-for="(item, index) in slotprops.value.record[slotprops.value.column.key]" :key="index">
                <img class="atch-img" :src="require('@/assets/ic-attachment.png')" />
                <a class="file-name input-label attachment" href="">
                  {{item.filename}}</a>
              </span>
            </div>

            <div v-if="slotprops.value.column.key=='fileType'">
              <span>
                <label class="file-type-label">
                  {{slotprops.value.record[slotprops.value.column.key]}}
                </label>
              </span>
            </div>
          </template> -->
          <!--<template v-slot:rowcontent="slotprops">
              <img class="sm-img" v-if="slotprops.value.column.key=='imgSrc'" :src="slotprops.value.record[slotprops.value.column.key]"
              />
              <p v-if="slotprops.value.column.key!='imgSrc' && slotprops.value.column.key!='LegalEntityForm24Q'  && slotprops.value.column.key !='file_location' && slotprops.value.column.key !='fileType'">{{slotprops.value.record[slotprops.value.column.key]}}</p>
              <div v-if="slotprops.value.column.key=='file_location'">
                  <img class="atch-img" :src="require('@/assets/ic-attachment.png')" />
                  <a class="file-name input-label attachment" :href="slotprops.value.record[slotprops.value.column.key]" target="blank" download=true>
                    {{slotprops.value.record[slotprops.value.column.key]}}</a>
              </div>
              <div v-if="slotprops.value.column.key=='fileType'">
                <span>
                  <label class="file-type-label">
                    {{slotprops.value.record[slotprops.value.column.key]}}
                  </label>
                </span>
              </div>
              <div v-if="slotprops.value.column.key=='LegalEntityForm24Q'">
                <p>{{slotprops.value.record[slotprops.value.column.key] ? slotprops.value.record[slotprops.value.column.key].quarter : ""}}</p>
              </div>
            </template>
        </data-table>
      </div>

    </div>-->

    <!-- <div class="margin-top-30">
      <btn class="custom-btn" text="Upload Acknowledgement" type="secondary" v-on:click="uploadAcknowledgement"></btn>
    </div> -->

    <div class="customGrid margin-top-30" :disabled="!ifTeamleaderAnchorPermission">
      <tl-radio label="Origin File" name="fileType" id="original_file" value="original" @change="(val)=>formData.file_type=val"
      />
      <tl-radio label="Revised File" name="fileType" id="revised_file" value="revised" @change="(val)=>formData.file_type=val" />
    </div>

    <div class="threeColumnGrid margin-top-20" :disabled="!ifTeamleaderAnchorPermission">
      <txt label="Enter acknowledgement number" type="number" v-model='formData.acknowledgement_no' name="acknowledgement_no"
        v-validate="'required'" :classname="errors.has('acknowledgement_no')" :errormsg="errors.first('acknowledgement_no')"
      />
      <div>
        <span class="feilds-label">Date of filing</span>
        <date-picker @datevalue="(val)=>formData.filling_date=val" :value="formData.filling_date" v-model="formData.filling_date"
          :formatDate="'dd-MM-yyyy'" name="filling_date" :classname="errors.has('filling_date')" v-validate="'required'" :errormsg="errors.first('filling_date')"
        />
      </div>
    </div>


    <div class="margin-top-20" :disabled="!ifTeamleaderAnchorPermission">
      <label class="upload-Acknowledgement-text"> Upload acknowledgement proof </label>
      <div class="margin-top-10">
        <upload @change="onFileChange($event)" :status="status"/>
      </div>
    </div>

    <bottom-action-container>
      <btn-grp slot="end">
        <btn text="Cancel" type="secondary" class v-on:click="cancel"></btn>
        <btn text="Save" type="primary" class v-on:click="save" :disabled="!ifTeamleaderAnchorPermission"></btn>
      </btn-grp>
    </bottom-action-container>

    <pop-up-message v-if="showSuccessMsg" :message="`Quarter acknowledgement file replaced successfully.`"
      btnText="Back" @back="closeModal"></pop-up-message>

    <pop-up-message v-if="showConfirmDelete" :message="'Are you sure you wish to delete ?'" :popupType="popupType" :popupHeaderMessage="'Confirm Delete'"
      >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="cancelEvent()">Cancel</button>
          <button class="btn-popup" type="button" @click="confirmDelete()">Delete</button>
        </div>
      </template>
    </pop-up-message>

  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from "vuex";

  export default {
    name: "uploadAcknowledgement",
    computed: {
      ...mapState({}),
      ...mapGetters({
        getleid: "onboard/legal_entities/legal_entity_ID"
      }),

      le_id() {
        if (this.$route.params.entity_index)
          return this.getleid(this.$route.params.entity_index);
        else {
          return this.getleid(0);
        }
      },
      ...mapState("onboard/organization", {
        orgIds: state => state.id
      }),
      ifTeamleaderAnchorPermission() {
        if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
          if(this.updateForm24qAcknowledgementValue) {
            return true;
          } else {
            return false;
          }
        }
        // else {
        //   return true
        // }
      }
    },
    data() {
      return {
        status: false,
        showConfirmDelete: false,
        popupType: "ConfirmDelete",
        currentObj: {},
        errmsg: "",
        toast: false,
        fileLocation: null,
        showSuccessMsg: false,
        quarterList: [],
        formData: {
          le_id: null,
          file_type: "",
          acknowledgement_no: "",
          filling_date: "",
          quarter_name: "",
          attachments:[],
        },
        acknowledgementData: [
        ],
        payGroupDataColumns: [
        {
          label: "Quarters",
          key: "LegalEntityForm24Q"
        },
        {
          label: "From Month",
          key: "fromMonth"
        },
        {
          label: "To Month",
          key: "toMonth"
        },
        {
          label: "Acknowledgement Number",
          key: "ack_no"
        },
        {
          label: "Filing Date",
          key: "filiing_date"
        },
        {
          label: "Attachements",
          key: "file_location"
        },
        {
          label: "",
          key: "fileType"
        }
        ],
        updateForm24qAcknowledgementValue: false,
        role: ""
      };
    },
    mounted() {
      this.fetchQuarters();
      this.getOrgLeIdList();
    },

    activated() {
      this.fetchQuarters();
      this.getOrgLeIdList();
    },

    methods: {
      ...mapActions({
        fetchAcknowledgementsByQuarter:
          "dashboard/organisation/utilities/form24Qacknowledgement/fetchAcksByQuarter",
        createAcknowledgementsByQuarter:
          "dashboard/organisation/utilities/form24Qacknowledgement/create",
        fetchAllQuarters: "onboard/form24Q/fetchAll",
        act_delete:
          "dashboard/organisation/utilities/form24Qacknowledgement/delete"
      }),

      quarterChanged(event) {
        //console.log("quarterChanged:", event);
        this.formData.quarter_name = event;
       //this.fetchAcknowledgementListByQuarter();
      },

      async fetchAcknowledgementListByQuarter() {
        try {

          let res = await this.fetchAcknowledgementsByQuarter(this.formData.le_id);
          //console.log("fetchAcknowledgementListByQuarter:", res);
          if (res.status == 200) {
            this.acknowledgementData = res.data.payload.data;
            this.acknowledgementData = [...this.acknowledgementData];
          }
        } catch (error) {
          //console.log("error", error);
          this.toast = true;
          this.errmsg = error;
        }
      },

      uploadAcknowledgement() { },

      cancel() { },

      save() {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.performAction().then(() => { });
          } else {
            this.showSuccessMsg = false;
          }
        });
      },
      async fetchQuarters() {
        try {
          this.formData.le_id = this.le_id;
          let res = await this.fetchAllQuarters(this.le_id);

          if (res.status == 200) {
            this.quarterList = res.data.payload.data.quarter;
            let quarterName= [];
            this.quarterList.forEach(element=>{
              quarterName.push(element.id);
            });
            ////console.log("Quater name",quarterName);
            this.quarterList = [...quarterName];

          }
        } catch (error) {
          //console.log("error", error);
          this.toast = true;
          this.errmsg = error;
        }
      },

      async performAction() {

        //console.log("performAction formData:", this.formData);
        let obj = {
          data: {
            le_id: this.le_id,
            financialYearId: null,
            ack_no: this.formData.acknowledgement_no,
            filiing_date: this.formData.filiing_date,
            file_location: this.fileLocation ? this.fileLocation : null,
            type: this.formData.fileType,
            quarter_id: this.formData.quarterValue ? this.formData.quarterValue.id : null,
            number: null
          }
        };

        try {

          //console.log("OBJ before send", obj);
          let res = await this.createAcknowledgementsByQuarter(this.formData);
          //console.log("createAcknowledgementsByQuarter:", res);
          if (res.status == 200 || res.status == 201) {
            this.fetchAcknowledgementListByQuarter();
            this.showSuccessMsg = true;
          }
        } catch (error) {
          //console.log("error", error);
          this.toast = true;
          this.errmsg = error;
        }
      },

      async onFileChange(event) {
        //console.log("onFileChange:", event);
        let url=event.data.location;
        this.formData.attachments.push(url);
        if (this.formData.attachments){
          this.status = true;
        }
      },

      closeModal() {
        this.refresh();
        this.showSuccessMsg = false;
        // this.$router.push({
        //   path: `/dashboard/${
        //     this.$route.params.entity_index
        //     }/organisation/utilities`
        // });
      },

      refresh() {
        this.formData = {
          //quarterValue: null,
          fileType: "",
          acknowledgementNumber: "",
          filiing_date: ""
        };
        this.fileLocation = null;
        this.status = false;
        //this.quarterList = [];
      },

      deleteItem(item) {
        this.showConfirmDelete = true;
        this.currentObj = item;
      },

      cancelEvent() {
        this.showConfirmDelete = false;
      },

      confirmDelete() {
        this.deleteEvent();
      },

      async deleteEvent() {
        try {
          let res = await this.act_delete(this.currentObj);
          //console.log("res", res);
          if (res.status == 200) {
            this.showConfirmDelete = false;
            this.fetchAcknowledgementListByQuarter();
          }
        } catch (err) {
          //console.log("error msg", err.message);
          this.toast = true;
          this.errmsg = err.message;
        }
      },
      ...mapActions({
          getOrgLeList: "onboard/organization/getOrgLeIdList",
      }),

      async getOrgLeIdList() {
          const org = this.orgIds;
          const le = this.le_id;
          //console.log("Org:",org);
          //console.log("Le ID",le);
          let bodyParams = {};
          let  data = await this.getOrgLeList({
            data: {
            ...bodyParams
          }});
          this.role = data.data.user.userRole;
          this.updateForm24qAcknowledgementValue = data.data.user.permissions.update_form_24q_acknowledgement ? true : false;
          //console.log("PL-3406",data);
      }
    },

  };
</script>

<style lang="scss" scoped>
  .margin-top-20 {
    margin-top: 20px;
  }

  .margin-top-30 {
    margin-top: 30px;
  }

  .margin-top-10 {
    margin-top: 10px;
  }

  .margin-top-6 {
    margin-top: 6px;
  }

  .tl-select-dropdown {
    margin-bottom: 0px;
  }

  .threeColumnGrid {
    grid-template-columns: 25% auto auto;
  }

  .upload-Acknowledgement-text {
    font-family: Montserrat;
    font-size: 12px;
    font-weight: normal;
    color: #646464;
  }

  .feilds-label {
    font-family: Montserrat;
    font-size: 12px;
    font-weight: normal;
    color: #646464;
  }

  .datepicker input {
    height: 35px;
  }

  .attachment {
    font-size: 14px;
    margin-left: 20px;
    margin-top: -24px;
  }

  .row-item {
    padding: 6px 8px;
  }

  .file-type-label {
    font-family: Montserrat;
    font-size: 14px;
    font-weight: normal;
    color: #5d409f;
  }

  .custom-btn {
    max-height: 35px;
    min-height: 35px;
    padding: 8px;
    font-size: 12px;
    font-weight: 600;
    font-style: normal;
  }

  .customGrid {
    display: grid;
    grid-template-columns: 17% 17% auto;
    grid-row-gap: 15px;
    grid-column-gap: 20px;
  }

  .permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
